export default "__VITE_ASSET__DnTrhMPK__";